// extracted by mini-css-extract-plugin
export var button = "_o1-0";